import React from "react";
import {
  Container,
  Logo,
  MainContainer,
  TopLeftContainer,
  TopLeftContentContainer,
  TopLeftContentStrong,
  TopRightHomeContainer,
  TopRightHomeContent,
  TopRightHomeIcon,
  TopRightMenuIcon,
  TopRightMenuIconContainer,
  TopRightMenuIconsContainer,
} from "./styles";
import logo from "../../assets/icons/Logo.svg";
import menu from "../../assets/icons/MobileMenu.svg";
import home from '../../assets/icons/Home.svg';

interface IHeader {
  onClickHamburger?: React.MouseEventHandler<HTMLDivElement>;
}

export const Header: React.FC<IHeader> = ({ onClickHamburger }) => {

  return (
    <MainContainer>
      <Container>
        <TopLeftContainer>
          <Logo src={logo}/>
          <TopLeftContentContainer>
            <TopLeftContentStrong>Central de Ajuda</TopLeftContentStrong>
          </TopLeftContentContainer>
        </TopLeftContainer>
        <TopRightHomeContainer href="https://www.cirurgiaautorizada.com.br/" target={'_blank'}>
          <TopRightHomeIcon src={home}/>
          <TopRightHomeContent>Ir para o site</TopRightHomeContent>
        </TopRightHomeContainer>
        <TopRightMenuIconsContainer>
          <a rel="noreferrer" style={{cursor: 'pointer',}} href="https://www.cirurgiaautorizada.com.br/" target="_blank">
            <TopRightMenuIcon className='dark-home' src={home}/>
          </a>
          <TopRightMenuIconContainer onClick={onClickHamburger}>
            <TopRightMenuIcon src={menu} />
          </TopRightMenuIconContainer>
        </TopRightMenuIconsContainer>
      </Container>
    </MainContainer>
  );
};
